<template>
  <v-menu
    class="m-date__container"
    v-model="menu2"
    transition="scale-transition"
    :close-on-content-click="false"
    offset-y
    :ref="'mdate_' + fieldData.model"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-if="showClearButton"
        class="m-date__clear"
        @click="clear()"
      >clear</v-icon>
      <v-text-field
        class="m-date__input"
        v-model="proxyValue"
        :label="fieldData.label"
        :hint="fieldData.hint"
        persistent-hint
        append-icon="event"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="menu2 = false"
    />
  </v-menu>
</template>
<script>
import mMixin from './mixin'

export default {
  name: 'm-date',
  mixins: [mMixin],
  data () {
    return {
      date: '',
      dateFormatted: '',
      menu1: false,
      menu2: false
    }
  },

  mounted () {
    this.$nextTick(function () {
      // console.log(this.fieldData)

      if (this.proxyValue) {
        const originalDate = (new Date(this.proxyValue))
        let formattedDate = new Date(originalDate.getTime() + 10800000)
        formattedDate = formattedDate.getFullYear() + '-' + (formattedDate.getMonth() + 1) + '-' + (formattedDate.getDate())
        this.date = formattedDate
      }
    })
  },

  computed: {
    showClearButton () {
      return this.date && this.date.length > 0
    }
  },

  watch: {
    date (val) {
      this.dateFormatted = this.date
      this.proxyValue = val
    }
  },

  methods: {
    parseDate (date) {
      if (!date) return null
      const divider = date.includes('-') ? '-' : '/'

      const [day, month, year] = date.split(divider)
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    clear () {
      this.date = ''
    }
  }
}
</script>
<style lang="scss">
.m-date__container {
  position: relative;
}

.m-date {
  &__clear {
    top: 30px;
    z-index: 1000;
    position: absolute !important;
  }

  &__input {
    z-index: 0;

    .v-text-field__slot input {
      text-align: right;
    }
  }
}

.field-date-picker {
  position: relative;
}
</style>
